/**
 * action types
 */
export const SET_ACTIVE_COHORT = 'SET_ACTIVE_COHORT';
export const UPDATE_COHORTS = 'UPDATE_COHORTS';
export const COHORT_ADD_ASSESSMENT_PRESET = 'COHORT_ADD_ASSESSMENT_PRESET';
export const COHORT_DELETE_ASSESSMENT_PRESET =
  'COHORT_DELETE_ASSESSMENT_PRESET';
export const UPDATE_COHORT_ASSESSMENT_SETTINGS =
  'UPDATE_COHORT_ASSESSMENT_SETTINGS';
export const SAVE_COHORT_ASSESSMENT_SETTINGS_START =
  'SAVE_COHORT_ASSESSMENT_SETTINGS_START';
export const SAVE_COHORT_ASSESSMENT_SETTINGS_FAILURE =
  'SAVE_COHORT_ASSESSMENT_SETTINGS_FAILURE';
export const ASSESSMENT_STATUS_FETCH_START = 'ASSESSMENT_STATUS_FETCH_START';
export const ASSESSMENT_STATUS_FETCH_SUCCESS =
  'ASSESSMENT_STATUS_FETCH_SUCCESS';
export const ASSESSMENT_STATUS_REFRESH_START =
  'ASSESSMENT_STATUS_REFRESH_START';
export const ASSESSMENT_STATUS_REFRESH_SUCCESS =
  'ASSESSMENT_STATUS_REFRESH_SUCCESS';
export const ASSESSMENT_STATUS_FETCH_FAILED = 'ASSESSMENT_STATUS_FETCH_FAILED';
